import { Injectable } from "@angular/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import * as CryptoJS from "crypto-js";
import { RebarAuthService } from "../rebarauth/rebar.auth.service";
import { AppConfigService } from "./app-config.service";
//import { TypeScriptEmitter } from '@angular/compiler';


declare var $: any;
const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Request-Headers": "Origin, Content-Type, Accept",
  }),
};

@Injectable({
  providedIn: "root",
})
export class CAPService {
  apiUrl = "";
  key: any = 7061737323313233;
  iv: any = 7061737323313233;
  country: any = "";
  CareerLevel: any = "";
  DisplayName: any = "";
  EmployeeNO: any = "";
  DeviceType: any = "";
  GDNGS: any = "";
  EncryptEid: any = "";
  Encryptcallcharge: any = "";
  token: any = "";
  ReportRole: any = "";
  Role: any = "";
  configData: any = "";
  public getUser: any[];
  public enterpriseid = "";
  UserCountry: any = "";

  constructor(
    private http: HttpClient,
    private auth: RebarAuthService,
    private config: AppConfigService
  ) {
    this.configData = this.config.getConfig();
    this.apiUrl = this.configData.apiURL;
  }

  //To call service original format.
  getAll(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + "api/", {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
  }
  encryptedlogin(Type) {
    var encryp = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(Type),
      this.key,
      {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encryp;
  }
  DecryptLogin(encrypted) {
    var decrypted = CryptoJS.AES.decrypt(encrypted, this.key, {
      iv: this.iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    return decrypted;
  }
  encryptData = function (input) {
    return this.DecryptLogin(input).toString(CryptoJS.enc.Utf8);
  };

  decryptData = function (input) {
    return this.encryptedlogin(input).ciphertext.toString(CryptoJS.enc.Base64);
  };
  //------------------------//
  getEntId() {
    if (
      window.sessionStorage.getItem("primaryLoggedIn") != "" &&
      window.sessionStorage.getItem("primaryLoggedIn") != null
    ) {
      this.enterpriseid = window.sessionStorage.getItem("primaryLoggedIn");
      this.enterpriseid = this.enterpriseid;
    } else {
      this.getUser = this.auth.getUser().split("@"); // MSAL V2 it was getUser().userName.split("@")
      this.enterpriseid = this.getUser[0];
      this.enterpriseid = this.enterpriseid;
    }
      return this.http.get(
      this.apiUrl +
        "api/Index/GetCurrentLoggedInEnterpriseId?enterpriseId=" +
        this.enterpriseid
    );
    //return this.http.post( this.apiUrl + "api/Index/GetCurrentLoggedInEnterpriseId/" ,
    //  {
       // enterpriseid : this.enterpriseid      
     // });
  }
  changeEntID(entID) {
    this.enterpriseid = entID;
    window.sessionStorage.setItem("primaryLoggedIn", entID);
  }
  GetDashboard(strDeviceType, strParam, strParam2, strCountry, strType) {
     return this.http.get<any[]>(
       this.apiUrl +
         "api/Dashboard/GetDashboard?strDeviceType=" +
         strDeviceType +
         "&strParam=" +
         strParam +
         "&strParam2=" +
        strParam2 +
         "&strCountry=" +
       strCountry +
         "&DeviceType=" +
         strType
     );
    //return this.http.post<any[]>(
     // this.apiUrl + "api/Dashboard/GetDashboard?strDeviceType/",{
       // strDeviceType: strDeviceType,
       // strParam: strParam,
       // strParam2: strParam2,
      //  strCountry: strCountry,
      //  strType: strType
     // });
  }
  AudiLogin(module, entId): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + "api/Admin/AudiLogin/?module=" + module + "&entId=" + entId
    );
  }
  CountryList(Country, strType): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<any[]>(this.apiUrl + "api/VoiceAdmin/CountryList/", {
      Country: Country,
      strType: strType,
    });
  }
  DestinationCountryList(Country, strType): Observable<any[]> {
    var Type = "DestinationCountry";
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<any[]>(this.apiUrl + "api/VoiceAdmin/CountryList/", {
      Country: Country,
      strType: strType,
      Type: Type,
    });
  }
  FacilityList(Country): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(this.apiUrl + "api/VoiceAdmin/FacilityList/", {
      Country: Country,
    });
  }
  AuthcodeFacility(strType): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + "api/VoiceAdmin/AuthcodeFacility?strType=" + strType
    );
  }
  GatewayList(DeviceType, strType, Country): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/GetVoiceAdminDetails/",
      { DeviceType: DeviceType, strType: strType, Country: Country }
    );
  }
  InsertVoiceAdminDetails(VoiceAdminDetails): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/InsertVoiceAdminDetails/",
      VoiceAdminDetails
    );
  }
  UpdateVoiceAdminDetails(UpdateVoiceAdmin): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/UpdateVoiceAdminDetails/",
      UpdateVoiceAdmin
    );
  }
  DeleteVoiceAdminDetails(
    ID1,
    strType,
    EnterpriseID,
    token
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/DeleteVoiceAdminDetails/",
      {
        ID1: ID1.toString(),
        strType: strType,
        EnterpriseID: EnterpriseID,
        token: token,
      }
    );
  }
  SearchDetails(CallRateName, Country, gateway, DeviceType, Type) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      {
        CallRateName: CallRateName,
        Country: Country,
        Facility: CallRateName,
        Name: gateway,
        DeviceType: DeviceType,
        Type: Type,
      }
    );
  }
  SearchDetailreportgerate(startDate,Enddate,enterpriseID, Type) {
    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      { 
        StartDate: startDate,
        EndDate:Enddate,
        EnterpriseID:enterpriseID, 
        Type: Type,
      }
    );
  }
  ExportDetails(CallRateName, Country, gateway, DeviceType, Type):Observable<Blob> {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<Blob>(
      this.apiUrl + "api/VoiceAdmin/SearchDetailsBulkDownload/",
      {
        CallRateName: CallRateName,
        Country: Country,
        Facility: CallRateName,
        Name: gateway,
        DeviceType: DeviceType,
        Type: Type,
      }
    );
  }
  SearchDetailsTeamsGateway(CallRateName, Country, gateway, DeviceType, Type) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      {
        CallRateName: CallRateName,
        Country: Country,
        Facility: CallRateName,
        Name: gateway,
        DeviceType: DeviceType,
        Type: Type,
      }
    );
  }
  GetVoiceAdminDetails(DeviceType, strType, Country) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/GetVoiceAdminDetails/",
      { DeviceType: DeviceType, strType: strType, Country: Country }
    );
  }
  SearchDetailsTeamsRate(CallRateName, Country, gateway, DeviceType, Type) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      {
        CallRateName: CallRateName,
        Country: Country,
        Facility: CallRateName,
        Name: gateway,
        DeviceType: DeviceType,
        Type: Type,
      }
    );
  }
  DropdownValues(FieldName, DeviceType) {
    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/DropdownValues/",
      { FieldName: FieldName, DeviceType: DeviceType }
    );
  }
  SearchDetailsNew(ProjectName, Country, Name, DeviceType, Type) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      {
        ProjectName: ProjectName,
        Country: Country,
        Facility: Name,
        Name: Name,
        DeviceType: DeviceType,
        Type: Type,
      }
    );
  }
  SearchDetailsTelco(
    CallRateName,
    Country,
    Name,
    DeviceType,
    Type,
    deviceName
  ) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      {
        CallRateName: CallRateName,
        Country: Country,
        Facility: CallRateName,
        Name: Name,
        DeviceType: DeviceType,
        Type: Type,
        deviceName: deviceName,
      }
    );
  }
  SearchDetailsCurrency(currencyName, Country, gateway, DeviceType, Type) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      {
        CallRateName: gateway,
        Country: Country,
        Facility: currencyName,
        Name: currencyName,
        DeviceType: DeviceType,
        Type: Type,
      }
    );
  }
  SearchDetailsConfig(UseCase, Country, gateway, DeviceType, Type) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      {
        CallRateName: UseCase,
        Country: Country,
        Facility: UseCase,
        Name: gateway,
        DeviceType: DeviceType,
        Type: Type,
      }
    );
  }
  SearchDetailsTeams(CallRateName, Country, gateway, DeviceType, Type) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/SearchDetails/",
      {
        CallRateName: CallRateName,
        Country: Country,
        Facility: CallRateName,
        Name: gateway,
        DeviceType: DeviceType,
        Type: Type,
      }
    );
  }

  // Kumar related API Function
  GetSummaryReportDetails(
    ReportDetails,
    strType,
    StartDate,
    EndDate
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/Reports/GetSummaryReportDetails?strType=" +
        strType +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate,
      ReportDetails
    );
  }
  GetReportDetails(
    ReportDetails,
    StartDate,
    EndDate,
    strType
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/Reports/GetReportDetails?strType=" +
        strType +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate,     
         ReportDetails
        );
      }
      GetReportDetail(
        ReportDetails,
       
        strType
      ): Observable<any[]> {
        return this.http.post<any[]>(
          this.apiUrl +
            "api/Reports/GetReportDetails?strType=" +
            strType ,
      
      ReportDetails
    );
  }
  GetLeaversDetails(
    strParam,
    strParam2,
    DeviceType,
    Country,
    EnterpriseID
  ): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.get<any[]>(
      this.apiUrl +
        "api/RequisitionToPay/GetLeaversDetails?strParam=" +
        strParam +
        "&strParam2=" +
        strParam2 +
        "&DeviceType=" +
        DeviceType +
        "&Country=" +
        Country +
        "&EnterpriseID=" +
        EnterpriseID
    );
  }
  UpdatePayDetails(strType, Data, EnterpriseID): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/RequisitionToPay/UpdatePayDetails?strType=" +
        strType +
        "&EnterpriseID=" +
        EnterpriseID,
      Data
    );
  }
  GetEnterpriseIDList(entId): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + "api/Reports/EmployeeName?entId=" + entId
    );
  }
  AutoPopulateGetEnterpriseIDList(entId): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + "api/Reports/AutoPopulateEmployeeName?entId=" + entId
    );
  }
  EditTemplate(Template, Id) {
    if (Template.Id == Id) {
      return "edit";
    } else {
      return "displayNew";
    }
  }
  GetRetaggingDetails(): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + "api/RequisitionToPay/GetRetaggingDetails"
    );
  }
  TransactRetaggingDetails(
    DeviceType,
    Posted,
    Cduration,
    strType
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/RequisitionToPay/TransactRetaggingDetails?DeviceType=" +
        DeviceType +
        "&Posted=" +
        Posted +
        "&Cduration=" +
        Cduration +
        "&strType=" +
        strType,
      null
    );
  }

  TransactRetaggingDetailsSearch(
    DeviceType,
    Posted,
    Cduration,
    Country,
    callStatus,
    EId,
    strType
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/RequisitionToPay/TransactRetaggingDetailsSearch?DeviceType=" +
        DeviceType +
        "&Posted=" +
        Posted +
        "&Cduration=" +
        Cduration +
        "&Country=" +
        Country +
        "&callStatus=" +
        callStatus +
        "&EId=" +
        EId +
        "&strType=" +
        strType,
      null
    );
  }

  // UpdateRetaggingDetails(params, data, strType): Observable<any[]> {
  //
  //   return this.http.post<any[]>(this.apiUrl + 'api/RequisitionToPay/UpdateRetaggingDetails/'+ {params:params}, '&data=' + data + '&strType=' + strType);
  // }
  UpdateRetaggingDetails(
    Remarks,
    Wbs,
    EId,
    approverEid,
    callStatus,
    data,
    strType
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/RequisitionToPay/UpdateRetaggingDetails?Remarks=" +
        Remarks +
        "&Wbs=" +
        Wbs +
        "&EId=" +
        EId +
        "&approverEid=" +
        approverEid +
        "&callStatus=" +
        callStatus +
        "&data=" +
        data +
        "&strType=" +
        strType,
      null
    );
  }
  LogIn(loggedInName) {
    this.enterpriseid = loggedInName;
    window.sessionStorage.setItem("primaryLoggedIn", loggedInName);
  }
  GetRoles(Country, Enterpriseid, strType): Observable<any[]> {
    debugger;

    if (Country == "China/Mainland") {
      Country = "China";
    }
   //CryptoJS.AES.encrypt(Country).toString();

    return this.http.post<any[]>(
      this.apiUrl + "api/Profile/GetProfileDetails",
      { Country: Country, Enterpriseid: Enterpriseid, strType: strType }

    );
  }
  WBSValidation(WBS): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + "api/Index/WBSValidation?WBS=" + WBS
    );
  }
  EnterpriseIdValidaton(EnterpriseID): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl +
        "api/Index/EnterpriseIdValidaton?EnterpriseID=" +
        EnterpriseID
    );
  }

  // Sridevi related API Function
  //Returns user access info
  GetUserAccessDetails(strParam, strType, strCountry): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl + "api/Admin/GetUserAccessDetails",
      { strParam: strParam, strType: strType, strCountry: strCountry }
    );
  }
  SearchUserAccessDetails(strParam, strType, strCountry): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl + "api/Admin/SearchUserAccessDetails",
      { strParam: strParam, strType: strType, strCountry: strCountry }
    );
  }
  UserAcessCountryList(Country, strType): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<any[]>(this.apiUrl + "api/VoiceAdmin/CountryList/", {
      Country: Country,
      strType: strType,
    });
  }
  UserEnterpriseIdValidaton(EnterpriseID): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/Authcode/EnterpriseIdValidaton?EnterpriseID=" +
        EnterpriseID,
      null
    );
  }
  //Include authentication method
  GetAuthcodeRequests(strType, EmployeeNO, Country): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<any[]>(
      this.apiUrl + "api/Authcode/GetAuthcodeRequests",
      { strType: strType, EmployeeNO: EmployeeNO, Country: Country }
    );
  }
  AuthCodeSearchRequest(
    strType,
    EmployeeNO,
    RoleDesc,
    userName,
    Active,
    roleName,
    strParam,
    selectedRoleNames,
    dlstStatus,
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl + "api/Authcode/GetAuthcodeRequests",
      {
        strType: strType,
        EmployeeNO: EmployeeNO,
        RoleDesc: RoleDesc,
        userName: userName,
        Active: Active,
        roleName: roleName,
        strParam: strParam,
        selectedRoleNames: selectedRoleNames,
        dlstStatus:dlstStatus,
      }
    );
  }
  UpdateAdminDetails(params, strType,enterpriseID): Observable<any[]> {
    let jsonFormat: any = JSON.stringify(params);
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };
    return this.http.post<any[]>(
      this.apiUrl + "api/Admin/UpdateAdminDetails?strType=" + strType + "&enterpriseID=" + enterpriseID,
      jsonFormat,
      headers
    );
  }
  submitFbsn(params): Observable<any[]> {
    let jsonFormat: any = JSON.stringify(params);
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };
    return this.http.post<any[]>(
      this.apiUrl + "api/Admin/submitFbsn",
      jsonFormat,
      headers
    );
  }
  DeleteAuthCode(AuthCodeDetails): Observable<any[]> {
    let jsonFormat: any = JSON.stringify(AuthCodeDetails);
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };
    return this.http.post<any[]>(
      this.apiUrl + "api/Authcode/DeleteAuthCode",
      jsonFormat,
      headers
    );
  }
  UpdateAuthCodeDetails(ModifiedData): Observable<any[]> {
    let jsonFormat: any = JSON.stringify(ModifiedData);
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };
    return this.http.post<any[]>(
      this.apiUrl + "api/Authcode/UpdateAuthCodeDetails",
      jsonFormat,
      headers
    );
  }
  AuthCodeDetails(
    RITMNumber,
    EnterpriseID,
    strType,
    Facility,
    authCodeId,
    managerID,
    LoggedInEnterprise
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/Authcode/AuthCodeDetails?RITMNumber=" +
        RITMNumber +
        "&EnterpriseID=" +
        EnterpriseID +
        "&strType=" +
        strType +
        "&Facility=" +
        Facility +
        "&authCodeId=" +
        authCodeId +
        "&managerID=" +
        managerID +
        "&LoggedInEnterprise=" +
        LoggedInEnterprise,
      null
    );
  }
  InsertAuthCodeDetails(AuthCodeDetails) {
    let jsonFormat: any = JSON.stringify(AuthCodeDetails);
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        Accept: "application/json",
      }),
    };
    return this.http.post<any[]>(
      this.apiUrl + "api/Authcode/InsertAuthCodeDetails/",
      jsonFormat,
      headers
    );
  }
  //Authenticate is to be added
  GetDeActivateAuthcodeRequests(strType, EmployeeNO, Country) {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/Authcode/GetAuthcodeRequests",
      { strType: strType, EmployeeNO: EmployeeNO, Country: Country }
    );
  }
  GetProfileDetails(Country, Enterpriseid, strType): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }

    return this.http.post<any[]>(
      this.apiUrl + "api/Profile/GetProfileDetails",
      { Country: Country, Enterpriseid: Enterpriseid, strType: strType }
    );
  }
  InsertProfileDetails(Country, Enterpriseid, strType): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<any[]>(
      this.apiUrl +
        "api/Profile/InsertProfileDetails?Country=" +
        Country +
        "&Enterpriseid=" +
        Enterpriseid +
        "&strType=" +
        strType,
      null
    );
  }
  GetGenerateProfileDetails(Country, EId, strType): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<any[]>(
      this.apiUrl + "api/Profile/GetGenerateProfileDetails",
      { Country: Country, EId: EId, strType: strType }
    );
  }
  InsertWBSEDetails(WBSEDetails, strType): Observable<any[]> {
    let jsonFormat: any = JSON.stringify(WBSEDetails);
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        // "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        // "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      }),
    };
    return this.http.post<any[]>(
      this.apiUrl + "api/Authcode/InsertWBSEDetails?strType=" + strType,
      jsonFormat,
      headers
    );
  }
  UserGetLoggedInEnterpriseId(): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl + "api/Authcode/GetCurrentLoggedInEnterpriseId",
      null
    );
  }
  GetFeedbackDetails(Id, Type, Country): Observable<any[]> {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<any[]>(this.apiUrl + "api/Admin/GetFeedbackDetails", {
      Id: Id,
      Type: Type,
      Country: Country,
    });
  }
  // SearchFeedbackDetails(Id, Type, Country): Observable<any[]> {
  //   if (Country == 'China/Mainland') { Country = "China"; }
  //   return this.http.post<any[]>(this.apiUrl + "api/Admin/GetFeedbackDetails", { Id: Id, Type: Type, Country: Country });
  // }
  InsertProfileOtherDetails(
    ProfileDetails,
    strType,
    EnterpriseID,
    CareerLevel,
    cdrId
  ): Observable<any[]> {
    let jsonFormat: any = JSON.stringify(ProfileDetails);
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        Accept: "application/json",
      }),
    };
    return this.http.post<any[]>(
      this.apiUrl +
        "api/Profile/InsertProfileOtherDetails/" +
        strType +
        "/" +
        EnterpriseID +
        "/" +
        CareerLevel +
        "/" +
        cdrId +
        "/",
      jsonFormat,
      headers
    );
  }
  // Export to Excel for Recovery ReportDetails

  ExportRecoveryReports(
    ReportDetails,
    StartDate,
    EndDate,
    strType
  ): Observable<any[]> {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/Reports/RecoveryReportsDownloadExcel?strType=" +
        strType +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate,
      ReportDetails
    );
  }
  UploadHostTemplate(formdata) {
    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/UploadHostTemplate/",
      formdata
    );
  }
  ExportRecoveryReports1(
    ReportDetails,
    StartDate,
    EndDate,
    strType
  ): Observable<Blob> {
    return this.http.post<Blob>(
      this.apiUrl +
        "api/Reports/RecoveryReportsBulkDownload?strType=" +
        strType +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate,
        ReportDetails,
        { responseType: "blob" as "json" }
      );
    }
    ExportAuthcodedecative(
      ReportDetails,
      
      strType
    ): Observable<Blob> {
      return this.http.post<Blob>(
        this.apiUrl +
          "api/Reports/RecoveryReportsBulkDownload?strType=" +
          strType ,
      
      ReportDetails,
      { responseType: "blob" as "json" }
    );
  }
  ExportSummaryReports1(
    ReportDetails,
    StartDate,
    EndDate,
    strType
  ): Observable<Blob> {
    return this.http.post<Blob>(
      this.apiUrl +
        "api/Reports/SummaryReportsBulkDownload?strType=" +
        strType +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate,
      ReportDetails,
      { responseType: "blob" as "json" }
    );
  }
  AuthCodeDetailsBulkDownload(strType, EmployeeNO, Country): Observable<Blob> {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<Blob>(
      this.apiUrl + "api/Authcode/GetActivateAuthcodeRequestsBulkDownload",
      { strType: strType, EmployeeNO: EmployeeNO, Country: Country },
      { responseType: "blob" as "json" }
    );
  }
  AuthCodeSearchRequestBulkDownload(
    strType,
    EmployeeNO,
    RoleDesc,
    userName,
    Active,
    roleName,
    strParam,
    selectedRoleNames,
    dlstStatus,
  ): Observable<Blob> {
    return this.http.post<Blob>(
      this.apiUrl + "api/Authcode/GetActivateAuthcodeRequestsBulkDownload",
      {
        strType: strType,
        EmployeeNO: EmployeeNO,
        RoleDesc: RoleDesc,
        userName: userName,
        Active: Active,
        roleName: roleName,
        strParam: strParam,
        selectedRoleNames: selectedRoleNames,
        dlstStatus:dlstStatus,
      },
      { responseType: "blob" as "json" }
    );
  }
  SearchDetailsBulkDownload(CallRateName, Country, gateway, DeviceType, Type) {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<Blob>(
      this.apiUrl + "api/VoiceAdmin/SearchDetailsBulkDownload/",
      {
        CallRateName: CallRateName,
        Country: Country,
        Facility: CallRateName,
        Name: gateway,
        DeviceType: DeviceType,
        Type: Type,
      },
      { responseType: "blob" as "json" }
    );
  }
  SearchDetailsTelcoBulkDownload(
    CallRateName,
    Country,
    Name,
    DeviceType,
    Type,
    deviceName
  ) {
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<Blob>(
      this.apiUrl + "api/VoiceAdmin/SearchDetailsBulkDownload/",
      {
        CallRateName: CallRateName,
        Country: Country,
        Facility: CallRateName,
        Name: Name,
        DeviceType: DeviceType,
        Type: Type,
        deviceName: deviceName,
      },
      { responseType: "blob" as "json" }
    );
  }
  // 2023 Requirement Source page
  SourceCountryList(Country, strType): Observable<any[]> {
    var Type = "SourceCountry";
    if (Country == "China/Mainland") {
      Country = "China";
    }
    return this.http.post<any[]>(this.apiUrl + "api/VoiceAdmin/CountryList/", {
      Country: Country,
      strType: strType,
      Type: Type,
    });
  }
  // 2023 Requirement GroupAccess page
  GetGroupAccessDetails(strParam, strType, strCountry): Observable<any[]> {
    // debugger;
    return this.http.post<any[]>(
      this.apiUrl + "api/Admin/GetGroupAccessDetails/",
      { strParam: strParam, strType: strType, strCountry: strCountry }
    );
  }
  UpdateGroupDetails(params, strType): Observable<any[]> {
    let jsonFormat: any = JSON.stringify(params);
    let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };
    return this.http.post<any[]>(
      this.apiUrl + "api/Admin/UpdateGroupAccessDetails?strType=" + strType,
      jsonFormat,
      headers
    );
  }
  //2023 Requirement Bulk Report Mail
  UploadBulkEidTemplate(userName, formdata) {
    return this.http.post<any[]>(
      this.apiUrl + "api/Reports/UploadBulkEidTemplate?UserName=" + userName,
      formdata
    );
  }
  TeamsCallRateBulkUploadHostTemplate(strType, formdata) {
    return this.http.post<any[]>(
      this.apiUrl +
        "api/VoiceAdmin/TeamsCallRateBulkUploadHostTemplate?strCallType=" +
        strType,
      formdata
    );
  }
  //Fetching Bulk template
  GetBulkTemplate(calltype): Observable<Blob> {
    return this.http.get<Blob>(
      this.apiUrl + "api/VoiceAdmin/DownloadBulkTemplate?strType=" + calltype,
      { responseType: "blob" as "json" }
    );
  }

   //Downloading User Manual due to ASA Vul fix for ASA Vulnerability
  GetUserManualDownload(calltype): Observable<Blob> {
    return this.http.get<Blob>(
      this.apiUrl + "api/VoiceAdmin/DownloadUserManual?strType=" + calltype,
      { responseType: "blob" as "json" }
    );
  }
  // SubmitSchedulerDetails(EmployeeNO,ReportDetails): Observable<any[]> {
  //   return this.http.post<any[]>(this.apiUrl + 'api/VoiceAdmin/RecoveryReportsDownloadExcel?strType=' + strType + '&StartDate=' + StartDate + '&EndDate=' + EndDate, ReportDetails);
  // }
  //Uploading sc bulk data
  BulkUpload(strType, formdata) {    
    return this.http.post<any[]>(
      this.apiUrl + "api/VoiceAdmin/BulkUpload?strType=" + strType,
      formdata
    );
  }
  UploadExitDeActivateAuthcode(strType,formdata) {
    debugger;
    return this.http.post<any[]>(this.apiUrl + "api/Authcode/UploadExitDeActivateAuthcode?strType=" + strType,formdata);
    }
  DownloadBulkTemplate(str): Observable<Blob> {
    return this.http.get<Blob>(
      this.apiUrl +
        "api/VoiceAdmin/ShortcodeDownloadBulkTemplate?strType=" +
        str,
      { responseType: "blob" as "json" }
    );
  }
}
